import React from 'react';
import styled from 'styled-components';
import Numbers2 from './Numbers2';

const Grid = ({onSelect, randomNumber, isEnabled, numbers2, status}) => {
  return (
    <Container>
      <Numbers2 numbers2={numbers2} isEnabled={isEnabled} randomNumber={randomNumber} onSelect={onSelect} />
    </Container>
  )
}

export default Grid;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 22vh;
  background-color: pink;
  background-color: #0f4166;
      background-color: ${({theme}) => theme.colors.background1};
  margin: 10px;
  border-radius: 5px;

`;